if (!customElements.get("c-wishlist-button")) {
  customElements.define(
    "c-wishlist-button",
    class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector(".js-wishlist-button__button");
        if (!this.button) return;

        this.isPending = false;

        this.button.addEventListener("click", this.wishlistButtonClickHandler);

        this.wishlistReadyUnsubscriber = window.PubSub?.subscribe?.("wishlist:ready", ({ state }) => {
          this.syncWithState();
        });

        this.wishlistUpdatedUnsubscriber = window.PubSub?.subscribe?.("wishlist:updated", ({ state }) => {
          this.syncWithState();
        });

        this.initWishlistState();
      }

      disconnectedCallback() {
        this.button?.removeEventListener("click", this.wishlistButtonClickHandler);
        this.wishlistReadyUnsubscriber?.();
        this.wishlistUpdatedUnsubscriber?.();
      }

      initWishlistState() {
        const state = window.WishlistStore?.getState?.();

        if (state?.initialized) {
          this.syncWithState();
          return;
        }

        this.updateWishlistButton(false);
      }

      getCurrentData() {
        const button = this.button;

        const productId = Number(
          this.dataset.productId ||
          button?.dataset.productId ||
          this.dataset.empi ||
          button?.dataset.empi
        );

        const variantId = Number(
          this.dataset.variantId ||
          button?.dataset.variantId ||
          this.dataset.epi ||
          button?.dataset.epi
        );

        console.log(this.dataset.handle);

        return {
          productId,
          variantId,
          url:
            this.dataset.url ||
            button?.dataset.url ||
            this.dataset.du ||
            button?.dataset.du ||
            "",
          handle:
            this.dataset.handle ||
            this.dataset.productHandle ||
            button?.dataset.handle ||
            button?.dataset.productHandle ||
            "",
          title:
            this.dataset.title ||
            button?.dataset.title ||
            "",
        };
      }

      getHandleFromUrl(url) {
        if (!url) return "";

        try {
          const cleanUrl = String(url).split("?")[0].replace(/\/$/, "");
          const parts = cleanUrl.split("/products/");

          return (parts[1] || cleanUrl.split("/").pop() || "").trim();
        } catch (error) {
          console.error("Failed to extract product handle from URL:", error);
          return "";
        }
      }

      getProductPayload() {
        const { productId, variantId, handle, url } = this.getCurrentData();

        const finalHandle = handle || this.getHandleFromUrl(url);

        if (!productId || Number.isNaN(productId) || !variantId || Number.isNaN(variantId) || !finalHandle) {
          throw new Error(
            `Invalid wishlist payload: productId=${productId}, variantId=${variantId}, handle=${finalHandle}`
          );
        }

        return {
          id: productId,
          variantId,
          handle: finalHandle,
          url: url || "",
        };
      }

      syncWithState = () => {
        const { variantId } = this.getCurrentData();

        if (!variantId || Number.isNaN(variantId)) {
          this.updateWishlistButton(false);
          return;
        }

        const inWishlist = Boolean(
          window.WishlistStore?.isInWishlist?.(variantId)
        );

        this.updateWishlistButton(inWishlist);
      };

      wishlistButtonClickHandler = async (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        if (this.isPending) return;

        this.isPending = true;
        this.button.disabled = true;

        try {

          const product = this.getProductPayload();
          const isCurrentlyInWishlist = Boolean(
            window.WishlistStore?.isInWishlist?.(product.variantId)
          );

          if (isCurrentlyInWishlist) {
            await window.WishlistStore?.remove?.(product);
          } else {
            await window.WishlistStore?.add?.(product);
          }
        } catch (error) {
          console.error("Wishlist action error:", error);
        } finally {
          this.isPending = false;
          this.button.disabled = false;
        }
      };

      updateWishlistButton = (inWishlist) => {
        if (!this.button) return;

        this.button.classList.toggle("added-to-wishlist", inWishlist);
        this.button.classList.toggle("is-active", inWishlist);
        this.button.dataset.action = inWishlist ? "delete" : "add";
        this.setAttribute("data-in-wishlist", inWishlist ? "true" : "false");
      };
    }
  );
}